module.exports = __webpack_public_path__ + "static/img/jianzhu09.79e021b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/Friend/jianzhu09.png
// module id = CqhY
// module chunks = 12